import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/updateAccountHeader/show/showSelector';

/** Returns true when TestTarget is ready and the updateAccountHeader offer's show flag is enabled. */
const showUpdateAccountHeaderSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showUpdateAccountHeaderSelector };
